import {
  AppBar,
  Box,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import Data from "common/data/index.json";
import MenuIcon from "@mui/icons-material/Menu";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import { LinkWithScroll, NavLinkWithScroll } from "./LinkWithScroll";
import logo from "assets/brand/logo.png";
import { useContext, useState } from "react";

const navLinkSx = {
  fontFamily: "'Lato', sans-serif",
  fontWeight: 400,
  fontSize: "0.78rem",
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "var(--common-black)",
  background: "none",
  border: "none",
  cursor: "pointer",
  padding: "8px 14px",
  position: "relative",
  transition: "color 0.3s ease",
  "&:hover": {
    color: "var(--clr-primary)",
    background: "none",
  },
};

const activeLinkSx = {
  ...navLinkSx,
  color: "var(--clr-primary)",
  "&::after": {
    content: "''",
    position: "absolute",
    bottom: 4,
    left: "50%",
    transform: "translateX(-50%)",
    width: "20px",
    height: "1.5px",
    backgroundColor: "var(--clr-primary)",
  },
};

export const Navbar = () => {
  const { language } = useContext(LanguageContext);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const renderNavLink = (link) => (
    <NavLinkWithScroll
      key={link.name}
      to={`${language}/${link.to}`}
      onClick={handleCloseNavMenu}
      style={{
        textDecoration: "none",
        display: "block",
      }}
    >
      {({ isActive }) => (
        <Box component="span" sx={isActive ? activeLinkSx : navLinkSx}>
          {link.name}
        </Box>
      )}
    </NavLinkWithScroll>
  );

  return (
    <>
      <AppBar
        color="secondary"
        elevation={0}
        sx={{
          zIndex: 1001,
          borderBottom: "1px solid rgba(192, 166, 97, 0.15)",
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ minHeight: { md: 70 } }}>
            {/* Desktop */}
            <Box
              width="100%"
              height="100%"
              display={{ xs: "none", md: "flex" }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" gap={0.5}>
                {Data[language].links.slice(0, 3).map(renderNavLink)}
              </Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="absolute"
                sx={{
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <LinkWithScroll
                  to={`/${language}/`}
                  style={{ position: "relative", display: "flex", alignItems: "center" }}
                >
                  <img
                    src={logo}
                    alt="logo casinhas do mémé"
                    height="55px"
                  />
                </LinkWithScroll>
              </Box>
              <Box display="flex" alignItems="center" gap={0.5}>
                {Data[language].links.slice(3, 5).map(renderNavLink)}
              </Box>
            </Box>

            {/* Mobile */}
            <Box
              width="100%"
              display={{ xs: "flex", md: "none" }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box>
                <IconButton
                  size="large"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  sx={{ color: "common.black" }}
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: "block", md: "none" },
                  }}
                  PaperProps={{
                    sx: {
                      borderRadius: 0,
                      mt: 1,
                    },
                  }}
                >
                  {Data[language].links.map((link) => (
                    <NavLinkWithScroll
                      key={link.name}
                      to={`${language}/${link.to}`}
                      style={{
                        color: "var(--common-black)",
                        textDecoration: "none",
                      }}
                    >
                      {({ isActive }) => (
                        <MenuItem
                          onClick={handleCloseNavMenu}
                          sx={{ py: 1.2, px: 3 }}
                        >
                          <Typography
                            sx={{
                              fontFamily: "'Lato', sans-serif",
                              fontSize: "0.8rem",
                              letterSpacing: "0.12em",
                              textTransform: "uppercase",
                              fontWeight: isActive ? 700 : 400,
                              color: isActive
                                ? "var(--clr-primary)"
                                : "var(--common-black)",
                            }}
                          >
                            {link.name}
                          </Typography>
                        </MenuItem>
                      )}
                    </NavLinkWithScroll>
                  ))}
                </Menu>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center">
                <LinkWithScroll
                  to={`/${language}/`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={logo}
                    alt="logo casinhas do mémé"
                    style={{ height: "45px" }}
                  />
                </LinkWithScroll>
              </Box>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Toolbar sx={{ minHeight: { md: 70 } }} />
    </>
  );
};
